import type { HeadingConfig } from "../../blockTypes";

interface HeadingBlockProps {
    config?: HeadingConfig;
}

const SIZE_CLASSES: Record<number, string> = {
    1: "text-2xl font-bold text-gray-900",
    2: "text-xl font-bold text-gray-900"
};
const DEFAULT_CLASSES = "text-lg font-semibold text-gray-900"; // Levels 3 and 4

const HeadingBlock = ({ config }: HeadingBlockProps) => {
    const text = config?.text ?? "";

    // Keeps the level inside 1-4, anything else falls back to the nearest one
    const level = Math.min(Math.max(config?.level ?? 1, 1), 4);
    const Tag = `h${level}` as "h1" | "h2" | "h3" | "h4";

    return <Tag className={SIZE_CLASSES[level] ?? DEFAULT_CLASSES}>{text}</Tag>;
};

export default HeadingBlock;